import { SURVEY_SINGAPORE, SET_NAME, SET_QUESTION_ANSWER, OPEN_POPUP, GET_FAMILY_INDEX, GET_CODE_MINOR_AGE_YMD, GET_QUESTIONS, GET_CODE_TODAY } from '@/store/actions/survey'
import { getTextByType, getFullTextByType } from '@/utils/survey'
import { mapGetters } from 'vuex'

export const REGEX = {
  VALID : {
    NUMBBER_ONLY: new RegExp('[0-9]{1}', '')
    , SSN_FIRST: new RegExp('[0-9]{6}', '')
    , SSN_LAST: new RegExp('[0-9]{7}', '')    
    , PASS_PORT: new RegExp('([a-zA-Z]{1}[0-9]{8}|[a-zA-Z]{2}[0-9]{7})$', '')    
    , PASS_PORT2 : new RegExp('[a-zA-Z0-9]{9,}','')
    , ENG_NUMBER_HYPEN : new RegExp('[a-zA-Z0-9-]{2,}','')
    , ENG_NUMBER : new RegExp('[a-zA-Z0-9]{2,}','')
    , ENG_ONLY : new RegExp('[a-zA-Z-]{2,}','')
    , KOR_ONLY : new RegExp('[ㄱ-ㅎ가-힣]{2,}','')
  },
  REPLACE: {
    NUMBBER_ONLY: new RegExp('[^0-9]', 'gi')
    , ENG_NUMBER_HYPEN : new RegExp('[^a-zA-Z0-9-]','gi')
    , ENG_NUMBER : new RegExp('[^a-zA-Z0-9]','gi')
    , ENG_ONLY : new RegExp('[^a-zA-Z-]','gi')
    , KOR_ONLY : new RegExp('[^ㄱ-ㅎ가-힣]', 'gi')
  }
  
}

export default {
  computed: {
    ...mapGetters(SURVEY_SINGAPORE, {
      getFamilyIdx: GET_FAMILY_INDEX,
      getMinorAgeYmd: GET_CODE_MINOR_AGE_YMD,
      getQuestion: GET_QUESTIONS,
      getCodeToday: GET_CODE_TODAY
    }),
  },
  methods: {
    getTextByType,
    getFullTextByType,
    getAttendantName(attendant) {
      if(attendant.type !== 'F') {
        return this.getFullTextByType(attendant);
      } else {
        return this.getTextByType(attendant) + (this.getFamilyIdx(attendant.type_seq) + 1);
      }
    },
    getPaymentMethodText(paymentMethod) {
      switch(paymentMethod.toLowerCase()) {
        case 'creditcard': return '신용카드';
        case 'banktransfer': return '계좌이체';
        default: return '기타';
      }
    },
    inputName(idx, name) {
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_NAME}`, { idx, name });
    },
    inputJuminNumber(idx, sq_code, target) {
      const value = target.value;
      const maxLength = target.maxLength;
      const raw_data = value.length > maxLength ? value.slice(0, maxLength) : value;
      const hasError = raw_data.length !== maxLength;
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError });
    },
    inputJuminFirstNumber(idx, sq_code, target) {
      const value = target.value;
      const maxLength = target.maxLength;
      let raw_data = value.length > maxLength ? value.slice(0, maxLength).replace(REGEX.REPLACE.NUMBBER_ONLY, "") : value.replace(REGEX.REPLACE.NUMBBER_ONLY, "");
      let notDomestic = false;
      
      // 내외국인 여부 체크 : 미선택시 입력항목 초기화 
      if ( !this.getQuestion[idx].questions['Q032'].raw_data ) {
        raw_data = '';
        notDomestic = true;        
      }

      let hasError = !REGEX.VALID.SSN_FIRST.test(raw_data) || raw_data.length !== maxLength;
      let remarks = null;

      // 주민번호를 모두 입력 시, 생년월일을 계산하여 미성년자 여부 체크 
      if (raw_data.length == maxLength && !hasError) { 
        const yy = new Number(raw_data.charAt(0)) > 2 ? 19000000 : 20000000;
        const userAge = new Number(yy) + new Number(raw_data);
        const minorAge = new Number(this.getMinorAgeYmd);        

        if (userAge > minorAge) { 
          hasError = true;
          remarks = "미성년자는 신청하실 수 없습니다."
        }
      }
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError, remarks });

      if (notDomestic) alert('내외국인 여부를 먼저 선택해 주세요.');
    },
    inputJuminLastNumber(idx, sq_code, target) {      
      const value = target.value;
      const maxLength = target.maxLength;
      const remarks = "";
      
      let raw_data = value.length > maxLength ? value.slice(0, maxLength).replace(REGEX.REPLACE.NUMBBER_ONLY, "") : value.replace(REGEX.REPLACE.NUMBBER_ONLY, "");
      let notDomestic = false;
      
      // 내외국인 여부 체크 : 미선택시 입력항목 초기화 
      if ( !this.getQuestion[idx].questions['Q032'].raw_data ) {
        raw_data = '';
        notDomestic = true;        
      }
      const hasError = !REGEX.VALID.SSN_LAST.test(raw_data) || raw_data.length !== maxLength;
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError, remarks });

      // 모든 자릿수를 입력했을 때, 성별을 판단, 홀수는 남성, 짝수는 여성
      sq_code = 'Q035'        
      if (raw_data.length == maxLength) { 
        raw_data = raw_data.charAt(0)%2 == 1 ? 'MALE': 'FEMALE';        
      } else {
        raw_data = null
      }
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError });

      if (notDomestic) alert('내외국인 여부를 먼저 선택해 주세요.');
      this.checkGender(idx);
      this.checkJunminLast(idx);
    },
    openPopupLayer(payload) {
      this.$store.dispatch(`${SURVEY_SINGAPORE}/${OPEN_POPUP}`, payload);
    },
    inputRadioAnswer(idx, sq_code, raw_data) {
      const hasError = false;
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError });
    },
    inputRadioDomesticAnswer(idx, sq_code, raw_data) {
      const hasError = false;
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError });
      this.checkGender(idx);
      this.checkJunminLast(idx);
    },
    inputRadioGenderAnswer(idx, sq_code, raw_data){
      // Radio 를 초기화 하고 싶은데, 잘되네요. 
      let hasError = false;
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError });

      const checkGenderResult = this.checkGender(idx);
      if (!checkGenderResult.status) {
        hasError = !checkGenderResult.status
        alert(checkGenderResult.message);
      }
    },
    checkJunminLast(idx){ 
      const ssn_data = this.getQuestion[idx].questions['Q033_2'].raw_data;
      const domestic_data = this.getQuestion[idx].questions['Q032'].raw_data;

      // 주민번호가 입력되었을 때만 체크 
      if (ssn_data) {
        const domestic_gender = domestic_data === 'DOMESTIC' ? true : false; // 내국인만 성별을 체크 
        const ssn_senven = new Number(ssn_data.charAt(0)); // 주민번호 뒷자리 기준의 성별, 0 : 여성, 1 : 남성 
        const ssn_gender = domestic_gender ? ssn_senven >= 1 && ssn_senven < 5 : ssn_senven >= 5 && ssn_senven < 9; 

        const sq_code = 'Q033_2';
        let raw_data = ssn_data;
        let hasError = this.getQuestion[idx].questions['Q033_2'].hasError;
        let remarks = ""
        
        if( raw_data.length < 7) { 
          hasError = !REGEX.VALID.SSN_LAST.test(raw_data);
          remarks = null;
        } else if (domestic_gender && !ssn_gender){
          hasError = true;
          remarks = "주민민등록번호 7번째 자리는 1,2,3,4 로 시작합니다."        
        } else if(!domestic_gender && !ssn_gender) {
          hasError = true;
          remarks = "외국인등록번호 7번째 자리는 5,6,7,8 로 시작합니다."        
        }else { 
          hasError = !REGEX.VALID.SSN_LAST.test(raw_data) || raw_data.length !== 7;
          remarks = null          
        }

        this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError, remarks });
      }
    },
    checkGender(idx) { 
      let result = {
        status : true,
        message : ''
      }

      const ssn_data = this.getQuestion[idx].questions['Q033_2'].raw_data;
      const domestic_data = this.getQuestion[idx].questions['Q032'].raw_data;
      const gender_data = this.getQuestion[idx].questions['Q035'].raw_data;

      if (ssn_data == '' || ssn_data == null) {
        result.message = '주민번호 뒷자리가 입력되지 않았습니다.';
        result.status = false;
        return result;
      }

      if (domestic_data == '' || domestic_data == null) {
        result.message = '내/외국인 항목이 선택되지 않았습니다.';
        result.status = false;
        return result;
      }

      if (gender_data == '' || gender_data == null) {
        result.message = '성별 항목이 선택되지 않았습니다.';
        result.status = false;
        return result;
      }

      const ssn_gender = ssn_data.charAt(0) % 2; // 주민번호 뒷자리 기준의 성별, 0 : 여성, 1 : 남성 
      const data_gender = gender_data == 'FEMALE' ? 0 : 1;  // 성별 선택 기준의 성별, 0 : 여성, 1 : 남성 
      const domestic_gender = domestic_data === 'DOMESTIC' ? true : false; // 내국인만 성별을 체크 

      if (data_gender !== ssn_gender && domestic_gender) {
        result.message = '입력하신 주민번호와 성별이 불일치 합니다.';
        result.status = false;
      }
      const sq_code = 'Q035';
      const raw_data = gender_data;
      const hasError = !result.status;
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError });

      return result;
    },
    inputPassportAnswer(idx, sq_code, target) {
      const value = target.value.toUpperCase();
      const maxLength = target.maxLength;
      const raw_data = value.length > maxLength ? value.slice(0, maxLength).replace(REGEX.REPLACE.ENG_NUMBER, "") : value.replace(REGEX.REPLACE.ENG_NUMBER, "");
      const hasError = !REGEX.VALID.PASS_PORT2.test(raw_data);
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError });
    },
    inputNumberAnswer(idx, sq_code, target, digitFix) {
      const value = target.value;
      const maxLength = target.maxLength;
      const raw_data = value.length > maxLength ? value.slice(0, maxLength).replace(REGEX.REPLACE.NUMBBER_ONLY, "") : value.replace(REGEX.REPLACE.NUMBBER_ONLY, "");
      const hasError = !REGEX.VALID.NUMBBER_ONLY.test(raw_data) || raw_data.length != digitFix
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError });
    },
    inputEngNumberAnswer(idx, sq_code, target) {
      const value = target.value;
      const maxLength = target.maxLength;
      const raw_data = value.length > maxLength ? value.slice(0, maxLength).replace(REGEX.REPLACE.ENG_NUMBER_HYPEN, "") : value.replace(REGEX.REPLACE.ENG_NUMBER_HYPEN, "");
      const hasError = !REGEX.VALID.ENG_NUMBER_HYPEN.test(raw_data);
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError });
    },
    inputEngAnswer(idx, sq_code, target) {
      const value = target.value.toUpperCase();
      const maxLength = target.maxLength;
      const raw_data = value.length > maxLength ? value.slice(0, maxLength).replace(REGEX.REPLACE.ENG_ONLY, "") : value.replace(REGEX.REPLACE.ENG_ONLY, ""); 
      const hasError = !REGEX.VALID.ENG_ONLY.test(raw_data);
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError });
    },
    inputKorAnswer(idx, sq_code, target) {
      const value = target.value;
      const maxLength = target.maxLength;
      const raw_data = value.length > maxLength ? value.slice(0, maxLength) : value;
      const hasError = !REGEX.VALID.KOR_ONLY.test(raw_data);
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError });
    },
    inputDateAnswer(idx, sq_code, target) {
      const value = target.value;
      const maxLength = target.maxLength;
      const raw_data = value.length > maxLength ? value.slice(0, maxLength) : value;
      const hasError = raw_data.length == 0 ? true : false;
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError });
    },
    inputSelectAnswer(idx, sq_code, selector, ...key) {   
      const raw_data = selector ? selector.value : key[0];
      const hasError = (raw_data === '' ? true : false)
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError });
    },
    inputAnyAnswer(idx, sq_code, target) {
      const value = target.value;
      const maxLength = target.maxLength;
      const raw_data = value.length > maxLength ? value.slice(0, maxLength) : value;
      const hasError = raw_data.length !== maxLength;
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError });
    },
    inputPassportDateAnswer(idx, sq_code, target) {
      const value = target.value;
      const maxLength = target.maxLength;
      const raw_data = value.length > maxLength ? value.slice(0, maxLength) : value;
      const hasError = raw_data.length == 0 ? true : false;
      this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code, raw_data, hasError, remarks:null });

      this.checkPassportCheck(idx);
    },
    checkPassportCheck(idx) {
      const passportFrom = this.getQuestion[idx].questions['Q038'];
      const passportTo = this.getQuestion[idx].questions['Q039'];

      // 여권 발급일 재 검증 
      if (!passportFrom.raw_data) { 
        this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code: 'Q038', raw_data:passportFrom.raw_data, hasError:true, remarks:null });
      } else if (passportFrom.raw_data > this.getCodeToday) { 
        this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code: 'Q038', raw_data:passportFrom.raw_data, hasError:true, remarks:'여권발급일은 오늘 이전이여야 합니다.' });
      } else if (passportFrom.raw_data === passportTo.raw_data) { 
        this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code: 'Q038', raw_data:passportFrom.raw_data, hasError:true, remarks:'여권발급일과 여권만료일이 같습니다.' });
      } else { 
        this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code: 'Q038', raw_data:passportFrom.raw_data, hasError:false, remarks:null });
      }
      
      // 여권 만료일 재 검증 
      if (!passportTo.raw_data) { 
        this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code: 'Q039', raw_data:passportTo.raw_data, hasError:true, remarks:null });
      } else if (passportTo.raw_data < this.getCodeToday) { 
        this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code: 'Q039', raw_data:passportTo.raw_data, hasError:true, remarks:'여권만료일은 오늘 이후이여야 합니다.' });
      } else if (passportFrom.raw_data === passportTo.raw_data) { 
        this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code: 'Q039', raw_data:passportTo.raw_data, hasError:true, remarks:'여권발급일과 여권만료일이 같습니다.' });
      } else { 
        this.$store.commit(`${SURVEY_SINGAPORE}/${SET_QUESTION_ANSWER}`, { idx, sq_code: 'Q039', raw_data:passportTo.raw_data, hasError:false, remarks:null });
      }
      
    }
  }
}


// WEBPACK FOOTER //
// ./src/views/surveys/singapore/mixins/CommonMethodMixin.js